export function getInitialInputValue(
  selectedValue?: string | number | null,
): string | number {
  return selectedValue ?? '';
}

export function shouldSyncSelectedValue(
  selectedValue: string | number | null | undefined,
  inputValue: string | number,
): selectedValue is string | number {
  return selectedValue != null && selectedValue !== inputValue;
}
